module.exports = __webpack_public_path__ + "7122b32bf4645bb05293e26a5a490962.pdf";